export const locale = {
  lang: "en",
  data: {
    SEARCH_BAR: {
      PLACEHOLDER: "Search",
    },
    TOOLBAR_RIGHT: {
      ONLINE: "On line",
      PROFILE: "Profile",
      MAIL: "Mail",
      LOGOUT: "Logout",
      EXEC: "Execute",
    },
    COMMANDS: {
      EXEC: "Execute",
      EXEC_QUESTION: "Are you sure you want to execute command?",
      CANCEL: "Cancel",
      EXEC_COMMAND: "Command execution",
      EXEC_SUCCESS: "Command executed successfully",
      EXEC_ERROR: "Command execution error",
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/main/toolbar/i18n/en.ts